// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"_1410954","container":"_2750900","option":"_85dc1d5","odds":"_5af8284","activeOption":"_5a0b281","toggle":"_6446028","startingPrice":"_0665374","oddsChanged":"_02db960"};